import React, { useEffect, useState } from "react";
import { Sparkles, X, RefreshCw } from "lucide-react";
import { APP_VERSION } from "@/lib/version";

const KEY = "pd_seen_version";

// Activates the waiting service worker (new deploy) or simply reloads.
export function applyUpdate() {
  const w = window.__swWaiting;
  if (w) { try { w.postMessage("SKIP_WAITING"); return; } catch (_) {} }
  window.location.reload();
}

function UpdateAvailableBar() {
  const [busy, setBusy] = useState(false);
  return (
    <div data-testid="version-update-banner" className="w-full bg-primary text-white px-4 py-2">
      <div className="max-w-[1400px] mx-auto flex items-center gap-3 text-sm">
        <Sparkles className="h-4 w-4 shrink-0" />
        <span className="font-semibold truncate min-w-0">Neue Version<span className="hidden sm:inline"> verfügbar</span></span>
        <span className="hidden sm:inline text-white/85 truncate">Laden Sie sie jetzt, um die neuesten Funktionen zu nutzen.</span>
        <div className="flex-1" />
        <button onClick={() => { setBusy(true); applyUpdate(); }} disabled={busy}
          data-testid="version-update-now-btn"
          className="shrink-0 inline-flex items-center gap-1.5 rounded-full bg-white text-primary hover:bg-white/90 transition-colors px-3 py-1 font-semibold disabled:opacity-70">
          <RefreshCw className={`h-3.5 w-3.5 ${busy ? "animate-spin" : ""}`} />Jetzt aktualisieren
        </button>
      </div>
    </div>
  );
}

// Banner: "Jetzt aktualisieren" when a new deploy is waiting, otherwise one-time "what's new" after an update.
export default function VersionBanner({ onDetails }) {
  const [show, setShow] = useState(false);
  const [updateReady, setUpdateReady] = useState(!!window.__swWaiting);

  useEffect(() => {
    let seen = null;
    try { seen = localStorage.getItem(KEY); } catch (_) {}
    if (seen !== APP_VERSION) setShow(true);
  }, []);

  useEffect(() => {
    window.__updateBannerMounted = true;
    const onUpdate = () => setUpdateReady(true);
    window.addEventListener("sw-update-available", onUpdate);
    return () => { window.__updateBannerMounted = false; window.removeEventListener("sw-update-available", onUpdate); };
  }, []);

  if (updateReady) return <UpdateAvailableBar />;

  const dismiss = () => {
    try { localStorage.setItem(KEY, APP_VERSION); } catch (_) {}
    setShow(false);
  };

  if (!show) return null;

  return (
    <div data-testid="version-banner"
      className="w-full bg-primary text-white px-4 py-2">
      <div className="max-w-[1400px] mx-auto flex items-center gap-3 text-sm">
        <Sparkles className="h-4 w-4 shrink-0" />
        <span className="font-semibold shrink-0">Neue Version {APP_VERSION}</span>
        <span className="hidden sm:inline text-white/85 truncate">ist aktiv – sehen Sie, was neu ist.</span>
        <div className="flex-1" />
        <button onClick={() => { onDetails && onDetails(); dismiss(); }}
          data-testid="version-banner-details"
          className="shrink-0 rounded-full bg-white/15 hover:bg-white/25 transition-colors px-3 py-1 font-medium">
          Was ist neu?
        </button>
        <button onClick={dismiss} data-testid="version-banner-dismiss"
          title="Ausblenden"
          className="shrink-0 rounded-full p-1 hover:bg-white/15 transition-colors">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
